import type {INormalize, Service} from "@raskrask-dk/raskrask-utils";
import type {IServiceDTO} from "..";
import type {IdValTuple, MapById} from "./mapper.types";
import type {PackageMapper} from "./PackageMapper";

export class ServiceMapper {
  constructor(private serviceConstructor: (serviceDTO: IServiceDTO) => Service, private packageMapper: PackageMapper) {}

  fromDTO(dto: IServiceDTO): Service {
    const service = this.serviceConstructor(dto);
    dto.packages.forEach((p) => this.packageMapper.fromDTO(p, service));
    return service;
  }

  fromDtoToTuple(dto: IServiceDTO): IdValTuple<Service> {
    return [dto.id, this.fromDTO(dto)];
  }

  fromNormalized(services: INormalize<IServiceDTO>): MapById<Service> {
    return new Map(services.allIds.map((id) => [parseInt(id), this.fromDTO(services.byId[id])]));
  }
}
